import React, { useState } from "react";

const PercentageDifferenceCalculator = () => {
  const [value1, setValue1] = useState('');
  const [value2, setValue2] = useState('');
  const [result, setResult] = useState('');
  const [explanation, setExplanation] = useState('');
  const [error, setError] = useState('');

  const handleCalculate = () => {
    if (!value1 || !value2) {
      setError('Veuillez entrer les deux valeurs correctement');
      setResult('');
      setExplanation('');
      return;
    }
    const val1 = parseFloat(value1);
    const val2 = parseFloat(value2);
    const diff = Math.abs(val1 - val2);
    const avgValue = (val1 + val2) / 2;
    const percentageDiff = (diff / avgValue) * 100;
    setResult(percentageDiff.toFixed(2));
    setExplanation(
      `Différence de pourcentage = |${val1} - ${val2}| / ((${val1} + ${val2}) / 2) × 100% = ${diff} / ${avgValue} × 100% = ${percentageDiff.toFixed(2)}%`
    );
    setError('');
  };

  return (
    <div>
      <u><h2 style={{ fontSize: '16px' }}>Calculatrice de différence de pourcentage</h2></u><br />
      <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '6px' }}>
        <span>Différence entre</span>
        <input
          type="number"
          placeholder="Valeur 1"
          value={value1}
          onChange={(e) => setValue1(e.target.value)}
          className="form-control"
          style={{ flex: 1, minWidth: '80px' }}
        />
        <span>et</span>
        <input
          type="number"
          placeholder="Valeur 2"
          value={value2}
          onChange={(e) => setValue2(e.target.value)}
          className="form-control"
          style={{ flex: 1, minWidth: '80px' }}
        />
        <button className="btn btn-success" onClick={handleCalculate}>Calculer</button>
      </div>
      <br />
      <div>
        {error !== '' ? (
          <p className="p-3 mb-2 bg-warning text-dark">Erreur: {error}</p>
        ) : (
          <>
            {result !== '' && (
              <>
                <p className="p-3 mb-2 bg-success text-white">
                  Résultat: la différence entre {value1} et {value2} est {result}%
                </p>
                {explanation !== '' && (
                  <p className="p-3 mb-2 bg-info text-dark">
                    Étapes: <br />{explanation}
                  </p>
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default PercentageDifferenceCalculator;
